module.exports = __webpack_public_path__ + "static/media/anuvadini-dash.5cdbe902.png";